import React from "react";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal, Space, Typography } from "antd";

const { Text } = Typography;

const DeleteConfirmation = ({
  visible,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
  itemName = "item",
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: "#faad14" }} />
          <span>{title}</span>
        </Space>
      }
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Delete"
      cancelText="Cancel"
      okType="danger"
      confirmLoading={loading}
      centered
      width={400}
    >
      <div style={{ padding: "16px 0" }}>
        <Text>{message}</Text>
        {itemName && itemName !== "item" && (
          <div style={{ marginTop: "8px" }}>
            <Text strong style={{ color: "#ff4d4f" }}>
              "{itemName}"
            </Text>
            <Text> will be permanently removed.</Text>
          </div>
        )}
        <div style={{ marginTop: "12px" }}>
          <Text type="secondary" style={{ fontSize: "13px" }}>
            This action cannot be undone.
          </Text>
        </div>
      </div>
    </Modal>
  );
};

// Hook for using delete confirmation
export const useDeleteConfirmation = () => {
  const [visible, setVisible] = React.useState(false);
  const [config, setConfig] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const showDeleteConfirmation = (options = {}) => {
    setConfig(options);
    setVisible(true);
  };

  const handleConfirm = async () => {
    if (config.onConfirm) {
      setLoading(true);
      try {
        await config.onConfirm();
        setVisible(false);
      } catch (error) {
        console.error("Delete operation failed:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setVisible(false);
    }
  };

  const handleCancel = () => {
    if (config.onCancel) {
      config.onCancel();
    }
    setVisible(false);
    setLoading(false);
  };

  const DeleteModal = () => (
    <DeleteConfirmation
      visible={visible}
      title={config.title}
      message={config.message}
      itemName={config.itemName}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      loading={loading}
    />
  );

  return {
    showDeleteConfirmation,
    DeleteModal,
    isLoading: loading,
  };
};

export default DeleteConfirmation;
